module.exports = __webpack_public_path__ + "img/titlelogo@3x.840a994e.png";